'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash.throttle');

var _lodash2 = _interopRequireDefault(_lodash);

var _reactackleButton = require('reactackle-button');

var _reactackleCore = require('reactackle-core');

var _reactackleIcons = require('reactackle-icons');

var _BreadcrumbsItem = require('./BreadcrumbsItem');

var _styles = require('./styles');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

(0, _reactackleCore.registerDefaultComponentTheme)('breadcrumbs', _styles.componentTheme);
var propTypes = {
  /**
   * Array of breadcrumbs items
   */
  items: _propTypes2.default.arrayOf(_propTypes2.default.shape(_BreadcrumbsItem.BreadcrumbsItem.propTypes)).isRequired,

  /**
   * If true, breadcrumbs will become scrollable to fit wrapper width
   */
  overflow: _propTypes2.default.bool,

  /**
   * Component to be used as a link in BreadcrumbItem
   */
  linkComponent: _propTypes2.default.func,

  /**
   * Define component's color scheme
   */
  colorScheme: _propTypes2.default.oneOf(['light', 'dark']),

  /**
   * Vertical align of items
   */
  alignItems: _propTypes2.default.oneOf(['top', 'center', 'bottom']),

  /**
   * Type of separator between items
   */
  separatorType: _propTypes2.default.oneOf(['text', 'icon']),

  /**
   * Define separator
   */
  separatorIcon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),

  /**
   * Function to be used on item's click
   */
  onItemClick: _propTypes2.default.func
};
var defaultProps = {
  linkComponent: null,
  overflow: false,
  colorScheme: 'dark',
  alignItems: 'center',
  separatorType: 'icon',
  separatorIcon: _react2.default.createElement(_reactackleIcons.IconArrowChevronRight, {
    size: 'custom',
    color: 'inherit'
  }),
  onItemClick: _reactackleCore.noop
};

var Breadcrumbs = function (_Component) {
  _inherits(Breadcrumbs, _Component);

  function Breadcrumbs(props) {
    _classCallCheck(this, Breadcrumbs);

    var _this = _possibleConstructorReturn(this, (Breadcrumbs.__proto__ || Object.getPrototypeOf(Breadcrumbs)).call(this, props));

    _this.itemDomNodes = new Map();
    _this.wrapperDomNode = null;
    _this.lastId = props.items.length - 1;
    _this.scrollAfterRender = false;
    _this.animateScroll = false;
    _this.animateEnd = true;
    _this.state = {
      showLeftButton: false,
      showRightButton: false,
      offset: 0,
      id: 0
    };
    _this._handleNext = _this._handleNext.bind(_this);
    _this._handlePrev = _this._handlePrev.bind(_this);
    _this._handleTransitionEnd = _this._handleTransitionEnd.bind(_this);
    _this._handleResize = (0, _lodash2.default)(_this._handleResize.bind(_this), 100);
    _this._saveWrapListRef = _this._saveWrapListRef.bind(_this);
    _this._saveItemRef = _this._saveItemRef.bind(_this);
    _this._saveContainerRef = _this._saveContainerRef.bind(_this);
    return _this;
  }

  _createClass(Breadcrumbs, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.containerDomNode.addEventListener('transitionend', this._handleTransitionEnd, false);

      this._showButtonsAndScroll(this.lastId);

      window.addEventListener('resize', this._handleResize, false);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.items !== this.props.items) {
        this.lastId = nextProps.items.length - 1;
        this.setState({
          showLeftButton: false,
          showRightButton: false,
          offset: 0,
          id: 0
        });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.items !== this.props.items) {
        this._showButtonsAndScroll(this.lastId);

        this.animateScroll = false;
      } else if (this.props.overflow && this.scrollAfterRender) {
        this._scrollToElement(this.state.id, this.state.id >= prevState.id);

        this.scrollAfterRender = false;
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this._handleResize, false);
      this.containerDomNode.removeEventListener('transitionend', this._handleTransitionEnd, false);
    }
  }, {
    key: '_isOverflow',
    value: function _isOverflow() {
      if (!this.props.overflow || this.itemDomNodes.size < 2) return false;
      var lastItem = this.itemDomNodes.get(this.lastId),
          firstItem = this.itemDomNodes.get(0),
          lastItemSize = lastItem.getBoundingClientRect(),
          firstItemSize = firstItem.getBoundingClientRect(),
          wrapListSize = this.wrapperDomNode.getBoundingClientRect(),
          overflowToRight = lastItemSize.right > wrapListSize.right,
          overflowToLeft = firstItemSize.left < wrapListSize.left;
      return overflowToRight || overflowToLeft;
    }
  }, {
    key: '_handleTransitionEnd',
    value: function _handleTransitionEnd() {
      this.animateEnd = true;
    }
  }, {
    key: '_handleResize',
    value: function _handleResize() {
      this.animateScroll = false;

      this._scrollToCurrent();
    }
  }, {
    key: '_showButtonsAndScroll',
    value: function _showButtonsAndScroll(id) {
      var newState = {
        showLeftButton: false,
        showRightButton: false,
        id: id
      };

      if (this._isOverflow()) {
        if (id === 0) {
          newState.showRightButton = true;
          newState.showLeftButton = false;
        }

        if (id === this.lastId) {
          newState.showRightButton = false;
          newState.showLeftButton = true;
        }

        if (id > 0 && id < this.lastId) {
          newState.showRightButton = true;
          newState.showLeftButton = true;
        }

        this.scrollAfterRender = true;
      }

      this.setState(newState);
    }
  }, {
    key: '_saveItemRef',
    value: function _saveItemRef(index, ref) {
      if (ref) this.itemDomNodes.set(index, ref);else this.itemDomNodes.delete(index);
    }
  }, {
    key: '_saveWrapListRef',
    value: function _saveWrapListRef(ref) {
      this.wrapperDomNode = ref;
    }
  }, {
    key: '_saveContainerRef',
    value: function _saveContainerRef(ref) {
      this.containerDomNode = ref;
    }
  }, {
    key: '_scrollToElement',
    value: function _scrollToElement(id, alignRight) {
      if (this.itemDomNodes.size && this.itemDomNodes.get(id)) {
        var elSize = this.itemDomNodes.get(id).getBoundingClientRect(),
            wrapperSize = this.wrapperDomNode.getBoundingClientRect();
        var offset = this.state.offset + elSize.left - wrapperSize.left;
        if (alignRight) offset -= wrapperSize.width - elSize.width;
        this.setState({
          offset: offset
        });
      }
    }
  }, {
    key: '_scrollToCurrent',
    value: function _scrollToCurrent() {
      this._showButtonsAndScroll(this.state.id);
    }
  }, {
    key: '_handleNext',
    value: function _handleNext() {
      if (!this.animateEnd) return;
      var wrapListSize = this.wrapperDomNode.getBoundingClientRect();
      var newId = this.state.id;

      while (newId < this.lastId) {
        newId += 1;
        if (!this.itemDomNodes.has(newId)) break;
        var newItem = this.itemDomNodes.get(newId),
            newItemSize = newItem.getBoundingClientRect();

        if (newItemSize.right > wrapListSize.right) {
          this._showButtonsAndScroll(newId);

          break;
        }
      }

      this.animateScroll = true;
      this.animateEnd = false;
    }
  }, {
    key: '_handlePrev',
    value: function _handlePrev() {
      if (!this.animateEnd) return;
      var wrapListSize = this.wrapperDomNode.getBoundingClientRect();
      var newId = this.state.id;

      while (newId > 0) {
        newId -= 1;
        if (!this.itemDomNodes.has(newId)) break;
        var newItem = this.itemDomNodes.get(newId),
            newItemSize = newItem.getBoundingClientRect();

        if (newItemSize.left < wrapListSize.left) {
          this._showButtonsAndScroll(newId);

          break;
        }
      }

      this.animateScroll = true;
      this.animateEnd = false;
    }
  }, {
    key: '_renderLeftButton',
    value: function _renderLeftButton() {
      if (!this.props.overflow || !this.state.showLeftButton) return null;
      return _react2.default.createElement(_styles.NavigationButtonStyled, {
        left: true
      }, _react2.default.createElement(_reactackleButton.Button, {
        icon: _react2.default.createElement(_reactackleIcons.IconArrowChevronLeft, {
          size: 'custom',
          color: 'inherit'
        }),
        onPress: this._handlePrev,
        colorScheme: this.props.colorScheme === 'light' ? 'flatLight' : 'flat'
      }));
    }
  }, {
    key: '_renderRightButton',
    value: function _renderRightButton() {
      if (!this.props.overflow || !this.state.showRightButton) return null;
      return _react2.default.createElement(_styles.NavigationButtonStyled, {
        right: true
      }, _react2.default.createElement(_reactackleButton.Button, {
        icon: _react2.default.createElement(_reactackleIcons.IconArrowChevronRight, {
          size: 'custom',
          color: 'inherit'
        }),
        onPress: this._handleNext,
        colorScheme: this.props.colorScheme === 'light' ? 'flatLight' : 'flat'
      }));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          separatorType = _props.separatorType,
          separatorIcon = _props.separatorIcon,
          linkComponent = _props.linkComponent,
          onItemClick = _props.onItemClick,
          colorScheme = _props.colorScheme,
          alignItems = _props.alignItems,
          items = _props.items;
      var BreadcrumbsItemsList = items.map(function (item, index, array) {
        return _react2.default.createElement(_BreadcrumbsItem.BreadcrumbsItem, _extends({
          index: index,
          title: item.title,
          subtitle: item.subtitle,
          separatorType: separatorType,
          separatorIcon: separatorIcon,
          home: item.home,
          itemHref: item.itemHref,
          isActive: index === array.length - 1,
          linkComponent: linkComponent,
          onClick: onItemClick,
          saveRef: _this2._saveItemRef,
          options: item.options,
          key: (0, _reactackleCore.getKey)(item, index),
          colorScheme: colorScheme
        }, item));
      });
      var style = {
        transform: 'translateX(-' + this.state.offset + 'px)'
      };
      if (this.animateScroll) style.transition = '0.3s ease-in-out';
      return _react2.default.createElement(_styles.BreadcrumbsStyled, {
        'aria-label': 'Breadcrumb'
      }, this._renderLeftButton(), _react2.default.createElement(_styles.ListWrapperStyled, {
        innerRef: this._saveWrapListRef
      }, _react2.default.createElement(_styles.ListStyled, {
        style: style,
        alignItems: alignItems,
        innerRef: this._saveContainerRef
      }, BreadcrumbsItemsList)), this._renderRightButton());
    }
  }]);

  return Breadcrumbs;
}(_react.Component);

exports.default = Breadcrumbs;
Breadcrumbs.propTypes = propTypes;
Breadcrumbs.defaultProps = defaultProps;